import { RotateCcw } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import type { ContinueOption } from '../positionOptions';

interface ContinueCardProps {
  item: ContinueOption;
  brandColor: string;
  onContinue: () => void;
}

/**
 * One unfinished interview, with its own Continue button.
 *
 * Every card carries the action regardless of how many there are: the gate's
 * footer CTA now belongs to the "apply for a different position" path, so a
 * card that relied on it would have no way to be continued.
 */
export function ContinueCard({ item, brandColor, onContinue }: ContinueCardProps) {
  const { t } = useTranslation('applyJob');

  return (
    <div
      className="flex items-center gap-3 rounded-xl border-[1.5px] p-3.5"
      style={{ borderColor: brandColor, background: `${brandColor}0b` }}
    >
      <span
        className="flex size-9 shrink-0 items-center justify-center rounded-full"
        style={{ background: `${brandColor}18` }}
      >
        <RotateCcw className="size-4" style={{ color: brandColor }} aria-hidden />
      </span>
      <div className="min-w-0 flex-1">
        <div className="text-[15px] font-bold leading-tight text-[#16171a]">
          {item.label}
        </div>
        <div className="mt-0.5 truncate text-xs text-[#6b7078]">
          {t('continue_gate_card_sub')}
        </div>
      </div>
      <button
        type="button"
        onClick={onContinue}
        aria-label={`${t('continue_button')} — ${item.label}`}
        className="h-9 shrink-0 whitespace-nowrap rounded-lg px-3.5 text-sm font-bold text-white"
        style={{ background: brandColor }}
      >
        {t('continue_button')}
      </button>
    </div>
  );
}
